import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { greyScaleColors, semanticColors } from '../../../Globals/styles';
import { connect } from 'react-redux';
import * as actions from './actions';
import { Scrollbars } from 'react-custom-scrollbars';

import auth from '../../../Login/authService'

class Chat extends Component {
  componentWillMount = () => {
    this.props.dispatch(actions.fetchChatMessages(this.props.activityId, 0, true));
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.activityId !== this.props.activityId)
      this.props.dispatch(actions.fetchChatMessages(nextProps.activityId, 0, true));
  };
  onScrollFrame = (scrollObj) => {
    const { activityId, dispatch, chatMessages, isFetching, stopLoadingMoreChatmessages } = this.props;
    if (!isFetching && scrollObj.top === 1 && !stopLoadingMoreChatmessages) {
      dispatch(actions.fetchChatMessages(activityId, chatMessages.length));
    }
  };
  submit = () => {
    if (this.refs.textArea.value.replace(/^\s+|\s+$/g, "").length < 1) return;
    this.props.dispatch(actions.addChatMessage(this.refs.textArea.value, auth.getProfile().name, this.props.activityId))
    this.refs.textArea.value = "";
  };
  renderSpinner = () => {
    return this.props.isFetching ? (<div style={styles.spinner}><i className="fa fa-spinner fa-spin fa-2x"></i></div>) : null;
  };
  render() {
    const { chatMessages } = this.props;
    const user = auth.getProfile();
    var date;
    var messages = chatMessages.map((chatMessage) => {
      let isOwn = chatMessage.fullName === user.name ? true : false;
      var shouldDisplayDate = false;
      if (date !== chatMessage.date) {
        shouldDisplayDate = true;
        date = chatMessage.date;
      }
      return (
        <div key={chatMessage.id}>
          {shouldDisplayDate ?
            <div style={styles.dateDelimiter}>
              <div style={styles.dateDelimiterLine}></div>
              <div style={styles.date}>{date}</div>
            </div>
            : null
          }
          <div style={styles.chatMessage}>
            <div style={[styles.header, isOwn && styles.headerOwn]}>{chatMessage.fullName}</div>
            <div style={[styles.message, isOwn && styles.messageOwn]}>{chatMessage.message}</div>
            <div style={[styles.time, isOwn && styles.timeOwn]}>{chatMessage.time}</div>
          </div>
        </div>
      )
    })
    return (
      <div style={styles.container}>
        <Scrollbars
          style={{ width: '100%', height: '100%' }}
          onScrollFrame={this.onScrollFrame}>
          <div ref="messageContainer">
            <div ref="messageInnerContainer">
              {messages}
              {this.renderSpinner()}
            </div>
          </div>
        </Scrollbars>
        <textArea ref="textArea" style={styles.textArea} placeholder="Skriv kommentar..." />
        <button style={styles.submitButton} className="btn btn-primary btn-block waves-btn" onClick={this.submit}>Send</button>
      </div>
    );
  }
}

var styles = {
  container: {
    height: '100%',
    paddingTop: '170px',
    position: 'relative',
    overflow: 'hidden'
  },
  submitButton: {
    width: '100%',
    position: 'absolute',
    top: '130px'
  },
  textArea: {
    position: 'absolute',
    top: '0',
    width: '100%',
    minHeight: '130px',
    resize: 'none',
    border: 'none',
    padding: '10px'
  },
  chatMessage: {
    width: '100%',
    margin: '5px 0'
  },
  header: {
    fontWeight: '600',
    fontSize: '15px'
  },
  headerOwn: {
    textAlign: 'right'
  },
  message: {
    borderRadius: '4px',
    backgroundColor: '#EBEEF0',
    padding: '10px',
    textAlign: 'justify',
    whiteSpace: 'pre-wrap'
  },
  messageOwn: {
    backgroundColor: semanticColors.primaryLight
  },
  time: {
    fontSize: '12px',
    textAlign: 'right',
    color: greyScaleColors.greyLight
  },
  timeOwn: {
    textAlign: 'right'
  },
  dateDelimiter: {
    height: '20px',
    position: 'relative'
  },
  dateDelimiterLine: {
    borderBottom: '1px solid ' + greyScaleColors.greyLight,
    position: 'absolute',
    top: '10px',
    width: '100%'
  },
  date: {
    backgroundColor: semanticColors.default,
    width: '150px',
    position: 'absolute',
    left: '45%',
    marginLeft: '-60px',
    textAlign: 'center'
  },
  spinner: {
    textAlign: 'center',
    marginBottom: '10px'

  }
}

const selectProps = state => {
  return {
    ...state.chatReducer,
  };
}
Chat.propTypes = {
  dispatch: PropTypes.func.isRequired,
  activityId: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired
};

export default connect(selectProps)(Radium(Chat));


// WEBPACK FOOTER //
// ./src/App/Project/RegisterActivities/Chat/index.jsx